import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

const TruckRegisterPage = () => {
  const navigate = useNavigate();
  const [step, setStep] = useState(1);
  const [form, setForm] = useState({
    driverName: '', phone: '', licenseNo: '',
    vehicleType: '', plateNo: '',
    bankName: '', bankAccount: '',
    startCity: '', endCity: '',
    departTime: '', availableCapacity: '',
    agreeTerms: false,
  });
  const [registered, setRegistered] = useState(false);

  const update = (key, val) => setForm(prev => ({ ...prev, [key]: val }));

  const cities = ['서울', '경기', '인천', '부산', '대구', '대전', '광주', '울산', '세종', '강원', '충북', '충남', '전북', '전남', '경북', '경남', '제주'];

  const vehicleTypes = [
    { val: 'damas', label: '🚐 다마스', cap: '300kg' },
    { val: '1ton', label: '🚚 1톤 트럭', cap: '1,000kg' },
    { val: '2.5ton', label: '🚛 2.5톤 트럭', cap: '2,500kg' },
    { val: '3.5ton', label: '🚜 3.5톤 트럭', cap: '3,500kg' },
    { val: '5ton', label: '🚛 5톤 트럭', cap: '5,000kg' },
    { val: '5ton_top', label: '🚛 5톤 탑차', cap: '5,000kg' },
  ];

  const canNext = () => {
    if (step === 1) return form.driverName && form.phone && form.licenseNo;
    if (step === 2) return form.vehicleType && form.plateNo;
    if (step === 3) return form.bankName && form.bankAccount;
    if (step === 4) return form.startCity && form.endCity && form.departTime && form.availableCapacity && form.agreeTerms;
    return false;
  };

  const stepTitles = ['기사 정보', '차량 등록', '정산 계좌', '운행 정보'];

  return (
    <div className="page-white">
      {/* 헤더 */}
      <div style={{ background: 'linear-gradient(135deg, #8E44AD 0%, #9B59B6 100%)', padding: '20px 20px 24px' }}>
        <button
          onClick={() => step > 1 ? setStep(step - 1) : navigate(-1)}
          style={{ background: 'rgba(255,255,255,0.2)', border: 'none', borderRadius: 10, padding: '8px 12px', color: 'white', cursor: 'pointer', marginBottom: 12 }}
        >← 뒤로</button>
        <div style={{ color: 'white', fontSize: 22, fontWeight: 800, marginBottom: 4 }}>
          🚚 용달차 등록
        </div>
        <div style={{ color: 'rgba(255,255,255,0.85)', fontSize: 13, marginBottom: 16 }}>
          공차 매칭으로 귀환 손실 없애기!
        </div>

        <div style={{ display: 'flex', gap: 4 }}>
          {stepTitles.map((title, i) => (
            <div key={i} style={{ flex: 1 }}>
              <div style={{
                height: 4, borderRadius: 2, marginBottom: 4,
                background: i < step ? 'white' : 'rgba(255,255,255,0.3)'
              }}/>
              <div style={{ fontSize: 9, color: i < step ? 'white' : 'rgba(255,255,255,0.5)', fontWeight: 600, textAlign: 'center' }}>
                {title}
              </div>
            </div>
          ))}
        </div>
      </div>

      <div style={{ padding: '24px 20px 100px' }}>
        {/* 공차 매칭 소개 */}
        <div style={{ background: '#f3e5f5', borderRadius: 16, padding: 16, marginBottom: 20 }}>
          <div style={{ fontWeight: 700, fontSize: 15, color: '#8E44AD', marginBottom: 8 }}>💜 공차 매칭이란?</div>
          <div style={{ fontSize: 13, color: '#5B2C6F', lineHeight: 1.7 }}>
            ① 놀고 있는 빈차 매칭<br/>
            ② 이사/배송 완료 후 귀환길에 추가 배송<br/>
            ③ 지방→서울 이동 중 도심 인근 물건 픽업
          </div>
        </div>

        <div style={{ background: '#FFF9E6', borderRadius: 12, padding: 14, marginBottom: 20, border: '1px solid #FFE0A0' }}>
          <div style={{ fontWeight: 700, fontSize: 14, color: '#B7791F' }}>STEP {step}. {stepTitles[step-1]}</div>
        </div>

        {/* Step 1: 기사 정보 */}
        {step === 1 && (
          <div>
            <div className="input-group">
              <label className="input-label">기사 성명</label>
              <input className="input-field" value={form.driverName} onChange={e => update('driverName', e.target.value)} placeholder="홍길동" />
            </div>
            <div className="input-group">
              <label className="input-label">연락처</label>
              <input className="input-field" value={form.phone} onChange={e => update('phone', e.target.value)} placeholder="010-0000-0000" />
            </div>
            <div className="input-group">
              <label className="input-label">운전면허 번호</label>
              <input className="input-field" value={form.licenseNo} onChange={e => update('licenseNo', e.target.value)} placeholder="서울 00-000000-00" />
            </div>
          </div>
        )}

        {/* Step 2: 차량 등록 */}
        {step === 2 && (
          <div>
            <div style={{ fontWeight: 700, fontSize: 15, color: '#1F2937', marginBottom: 12 }}>차량 유형</div>
            {vehicleTypes.map(v => (
              <div
                key={v.val}
                onClick={() => update('vehicleType', v.val)}
                style={{
                  display: 'flex', alignItems: 'center', justifyContent: 'space-between',
                  padding: '14px 16px', border: `2px solid ${form.vehicleType === v.val ? '#8E44AD' : '#E5E7EB'}`,
                  borderRadius: 12, background: form.vehicleType === v.val ? '#f3e5f5' : 'white',
                  marginBottom: 8, cursor: 'pointer'
                }}
              >
                <div>
                  <div style={{ fontWeight: 700, fontSize: 14 }}>{v.label}</div>
                  <div style={{ fontSize: 12, color: '#9CA3AF' }}>최대 {v.cap}</div>
                </div>
                {form.vehicleType === v.val && <span style={{ color: '#8E44AD', fontWeight: 700 }}>✓</span>}
              </div>
            ))}

            <div className="input-group" style={{ marginTop: 16 }}>
              <label className="input-label">🔢 차량 번호판</label>
              <input className="input-field" value={form.plateNo} onChange={e => update('plateNo', e.target.value)} placeholder="예: 서울 12가 3456" />
            </div>

            <div style={{ background: '#f3e5f5', borderRadius: 12, padding: 14 }}>
              <div style={{ fontSize: 13, color: '#5B2C6F', lineHeight: 1.7 }}>
                ✅ 차량 등록증 사본 제출 필요<br/>
                ✅ 화물운송 사업자 등록증 (사업자의 경우)<br/>
                ✅ 차량 보험 가입 필수
              </div>
            </div>
          </div>
        )}

        {/* Step 3: 정산 계좌 */}
        {step === 3 && (
          <div>
            <div className="input-group">
              <label className="input-label">🏦 은행</label>
              <select className="input-field" value={form.bankName} onChange={e => update('bankName', e.target.value)}>
                <option value="">은행 선택</option>
                {['국민은행', '신한은행', '우리은행', '하나은행', 'IBK기업은행', '농협은행', '카카오뱅크', '토스뱅크'].map(b => (
                  <option key={b} value={b}>{b}</option>
                ))}
              </select>
            </div>
            <div className="input-group">
              <label className="input-label">💳 계좌번호</label>
              <input className="input-field" value={form.bankAccount} onChange={e => update('bankAccount', e.target.value)} placeholder="본인 명의 계좌" />
            </div>

            <div style={{ background: '#e8f8ef', borderRadius: 12, padding: 14 }}>
              <div style={{ fontWeight: 700, fontSize: 14, color: '#27AE60', marginBottom: 6 }}>💰 정산 안내</div>
              <div style={{ fontSize: 13, color: '#166534', lineHeight: 1.7 }}>
                • 배송 완료 후 익일 자동 정산<br/>
                • 수수료: 배송비의 15% (플랫폼 수수료)<br/>
                • 주 2회 정산 (화요일, 금요일)
              </div>
            </div>
          </div>
        )}

        {/* Step 4: 운행 정보 */}
        {step === 4 && (
          <div>
            <div style={{ fontWeight: 700, fontSize: 15, color: '#1F2937', marginBottom: 12 }}>🛣️ 오늘 운행 정보</div>

            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 10, marginBottom: 16 }}>
              <div>
                <label className="input-label">출발지</label>
                <select className="input-field" value={form.startCity} onChange={e => update('startCity', e.target.value)}>
                  <option value="">선택</option>
                  {cities.map(c => <option key={c} value={c}>{c}</option>)}
                </select>
              </div>
              <div>
                <label className="input-label">도착지</label>
                <select className="input-field" value={form.endCity} onChange={e => update('endCity', e.target.value)}>
                  <option value="">선택</option>
                  {cities.map(c => <option key={c} value={c}>{c}</option>)}
                </select>
              </div>
            </div>

            <div className="input-group">
              <label className="input-label">⏰ 예상 도착 시간</label>
              <input
                className="input-field"
                type="time"
                value={form.departTime}
                onChange={e => update('departTime', e.target.value)}
              />
            </div>

            <div className="input-group">
              <label className="input-label">📦 적재 여유 (선택)</label>
              <select className="input-field" value={form.availableCapacity} onChange={e => update('availableCapacity', e.target.value)}>
                <option value="">여유 공간 선택</option>
                <option value="small">소형 물건만 (다마스급)</option>
                <option value="medium">중형 가구 가능 (소파 등)</option>
                <option value="large">대형 가구 가능 (장롱 등)</option>
                <option value="full">여유 공간 충분</option>
              </select>
            </div>

            {/* 지도 경로 미리보기 */}
            {form.startCity && form.endCity && (
              <div style={{ background: '#f3e5f5', borderRadius: 14, padding: 16, marginBottom: 16 }}>
                <div style={{ fontWeight: 700, fontSize: 14, color: '#8E44AD', marginBottom: 8 }}>🗺️ 운행 경로</div>
                <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                  <span style={{ fontSize: 20 }}>📍</span>
                  <span style={{ fontWeight: 700, color: '#1F2937' }}>{form.startCity}</span>
                  <div style={{ flex: 1, height: 2, background: '#CE93D8' }}/>
                  <span style={{ fontSize: 14 }}>🚚</span>
                  <div style={{ flex: 1, height: 2, background: '#CE93D8' }}/>
                  <span style={{ fontWeight: 700, color: '#1F2937' }}>{form.endCity}</span>
                  <span style={{ fontSize: 20 }}>🏠</span>
                </div>
                <div style={{ marginTop: 8, fontSize: 12, color: '#6B7280' }}>
                  이 경로 주변의 배송 요청을 자동으로 매칭해 드립니다
                </div>
              </div>
            )}

            <div
              onClick={() => update('agreeTerms', !form.agreeTerms)}
              style={{ display: 'flex', alignItems: 'center', gap: 10, padding: '14px', border: `2px solid ${form.agreeTerms ? '#8E44AD' : '#E5E7EB'}`, borderRadius: 12, cursor: 'pointer', marginBottom: 16 }}
            >
              <div style={{
                width: 22, height: 22, borderRadius: 6, border: `2px solid ${form.agreeTerms ? '#8E44AD' : '#D1D5DB'}`,
                background: form.agreeTerms ? '#8E44AD' : 'white',
                display: 'flex', alignItems: 'center', justifyContent: 'center'
              }}>
                {form.agreeTerms && <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="3"><polyline points="20 6 9 17 4 12"/></svg>}
              </div>
              <span style={{ fontSize: 14, color: '#4B5563', fontWeight: 500 }}>서비스 이용약관 및 개인정보 처리 동의</span>
            </div>
          </div>
        )}

        {step < 4 ? (
          <button
            onClick={() => canNext() && setStep(step + 1)}
            disabled={!canNext()}
            style={{
              width: '100%', padding: '16px', borderRadius: 16,
              background: canNext() ? '#8E44AD' : '#E5E7EB',
              color: canNext() ? 'white' : '#9CA3AF',
              border: 'none', fontWeight: 800, fontSize: 16, cursor: canNext() ? 'pointer' : 'not-allowed'
            }}
          >다음 단계 →</button>
        ) : (
          <button
            onClick={() => canNext() && setRegistered(true)}
            disabled={!canNext()}
            style={{
              width: '100%', padding: '16px', borderRadius: 16,
              background: canNext() ? '#8E44AD' : '#E5E7EB',
              color: canNext() ? 'white' : '#9CA3AF',
              border: 'none', fontWeight: 800, fontSize: 16,
              cursor: canNext() ? 'pointer' : 'not-allowed',
              boxShadow: canNext() ? '0 4px 16px rgba(142,68,173,0.4)' : 'none'
            }}
          >🚚 운행 등록 완료</button>
        )}
      </div>

      {/* 등록 완료 */}
      {registered && (
        <div style={{
          position: 'fixed', inset: 0, background: 'white',
          display: 'flex', flexDirection: 'column', alignItems: 'center',
          justifyContent: 'center', padding: 40, textAlign: 'center', zIndex: 999
        }}>
          <div style={{ fontSize: 80, marginBottom: 20 }}>🚚</div>
          <div style={{ fontWeight: 800, fontSize: 24, color: '#1F2937', marginBottom: 8 }}>운행 등록 완료!</div>
          <div style={{ fontSize: 15, color: '#6B7280', lineHeight: 1.8, marginBottom: 24 }}>
            <strong style={{ color: '#8E44AD' }}>{form.startCity} → {form.endCity}</strong> 경로로<br/>
            공차 매칭이 시작됩니다.<br/>
            주변 배송 요청을 실시간으로 알려드립니다! 🔔
          </div>
          <div style={{ background: '#f3e5f5', borderRadius: 14, padding: 16, width: '100%', marginBottom: 24 }}>
            <div style={{ fontSize: 14, color: '#5B2C6F', lineHeight: 1.8 }}>
              📍 {form.startCity} → {form.endCity}<br/>
              🚚 {vehicleTypes.find(v => v.val === form.vehicleType)?.label || '차량 등록 완료'}<br/>
              🔢 {form.plateNo}<br/>
              ⏰ 예상 도착: {form.departTime}
            </div>
          </div>
          <button
            onClick={() => navigate('/truck-match')}
            style={{
              background: '#8E44AD', color: 'white', border: 'none',
              borderRadius: 16, padding: '16px 40px', fontWeight: 800, fontSize: 16, cursor: 'pointer'
            }}
          >공차 매칭 현황 보기</button>
        </div>
      )}
    </div>
  );
};

export default TruckRegisterPage;
